<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
      <sub-tabs nomeSessao="Atendimento"></sub-tabs>
  </v-container>
</template>

<script>
import subTabs from '@/components/painel/SubTabs'
export default {
  name: 'PAtendimento',
  components: {
    'sub-tabs': subTabs
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?06862daa